<!--
 * @Author: yangxu
 * @Description: 
 * @Date: 2023-07-11 14:31:03
 * @LastEditTime: 2025-03-13 09:33:11
 * @FilePath: /js_zuhe-2023_src/src/components/CombinationIncome.vue
-->
<template>
  <div class="padding_15 combinationIncome">
    <div class="positionTitle">组合收益</div>
    <div>
      <div class="dateTbas">
        <div @click="changeTabs(0)" :class="dateTabs == 0 ? 'active' : ''">
          近3月
        </div>
        <div @click="changeTabs(1)" :class="dateTabs == 1 ? 'active' : ''">
          近1年
        </div>
        <div @click="changeTabs(2)" :class="dateTabs == 2 ? 'active' : ''">
          今年以来
        </div>
        <div @click="changeTabs(3)" :class="dateTabs == 3 ? 'active' : ''">
          全部
        </div>
      </div>
      <div class="echartsIllustrate">
        <div class="date">
          {{ handelEchartsData && handelEchartsData[0].axisValue }}
          {{ setWeekend(handelEchartsData && handelEchartsData[0].axisValue) }}
        </div>
        <div class="illustrate">
          <div>
            <div>
              <span class="combination"></span>
              投资组合
            </div>
            <div
              :class="setColor(handelEchartsData && handelEchartsData[0].value)"
            >
              {{
                handelEchartsData && handelEchartsData[0].value
                  ? `${handelEchartsData[0].value > 0 ? "+" : ""}${
                      handelEchartsData[0].value
                    }%`
                  : "--"
              }}
            </div>
          </div>
          <div>
            <div>
              <span class="hushen"></span>
              沪深
            </div>
            <div
              :class="setColor(handelEchartsData && handelEchartsData[1].value)"
            >
              {{
                handelEchartsData && handelEchartsData[1].value
                  ? `${handelEchartsData[1].value > 0 ? "+" : ""}${
                      handelEchartsData[1].value
                    }%`
                  : "--"
              }}
            </div>
          </div>
        </div>
      </div>
      <div class="echarts" ref="showorders" id="showorders">
        <Empty />
      </div>
    </div>
  </div>
</template>

<script setup>
// 从 Vue 中导入 ref, onMounted, nextTick, watchEffect 钩子
import { ref, onMounted, nextTick, watchEffect } from "vue";

// 从 API 模块中导入 getDetail 和 getStockDetail 函数
import { getDetail, getStockDetail } from "@/api";
// 从工具模块中导入 format, parseJSONP, toDecimal 函数
import { format, parseJSONP, toDecimal, getUrlParam } from "@/utils/Util";
// 导入空状态
import Empty from "@/components/Empty.vue"; // 导入 Empty 组件，用于数据为空时的展示

// 从 Vuex 中导入 useStore 函数
import { useStore } from "vuex";
// 创建 Vuex store 实例
const store = useStore();
// 定义一个响应式的数值变量，用于存储当前选中的日期标签索引
const dateTabs = ref(0);

// 定义一个函数，用于计算两个日期之间的天数差
function getDayDifference(startDate, endDate) {
  // 如果 startDate 或 endDate 为空，返回 9999
  if (startDate == "" || endDate == "") {
    return 9999;
  }
  // 将 startDate 转换为时间戳（毫秒）
  const startTime = new Date(startDate).getTime();
  // 将 endDate 转换为时间戳（毫秒）
  const endTime = new Date(endDate).getTime();

  // 计算时间差（毫秒）
  const timeDifference = endTime - startTime;

  // 将毫秒转换为天数
  return Math.floor(timeDifference / (1000 * 60 * 60 * 24));
}
// 从 URL 获取客户端 ID 参数
const id = getUrlParam("id");

// 定义一个响应式的对象变量，用于存储请求参数
const parameter = ref({});
// 使用 watchEffect 监听 store 中的状态变化，并更新 parameter
watchEffect(() => { //NOSONAR
  // 获取当前日期
  const now = new Date();
  // 获取一年前的日期
  const threeMounthAgo = new Date(now);
  threeMounthAgo.setMonth(now.getMonth() - 3);
  // 设置 parameter 的 start_date 为一年前的日期
  parameter.value.start_date = format(new Date(threeMounthAgo), "YYYY-MM-DD");
  // 设置 parameter 的 end_date 为当前日期
  parameter.value.end_date = format(new Date(), "YYYY-MM-DD");
  // 更新 parameter 对象
  parameter.value = {
    advisor_id: store.state.detail?.product?.advisor_id, // 顾问 ID
    product_id: id, // 产品 ID
    start_date: format(threeMounthAgo, "YYYY-MM-DD"), // 开始日期
    end_date: format(now, "YYYY-MM-DD"), // 结束日期
    count: getDayDifference(threeMounthAgo, now), // 天数差
    product_type: 2, // 产品类型
  };
});
// 定义一个响应式的数组变量，用于存储收益数据
const rateData = ref([]);

// 定义一个函数，用于切换日期标签
const changeTabs = (index) => {
  // 如果当前选中的标签索引与传入的索引相同，直接返回
  if (dateTabs.value == index) return;
  // 更新当前选中的标签索引
  dateTabs.value = index;
  // 定义按钮名称变量
  let dplusButtonName = "";
  // 获取当前日期
  const now = new Date();
  // 根据传入的索引设置不同的日期范围
  switch (index) {
    case 0:
      // 设置 start_date 为三个月前的日期
      parameter.value.start_date = format(
        new Date(now.setMonth(now.getMonth() - 3)),
        "YYYY-MM-DD"
      );
      // 设置 end_date 为当前日期
      parameter.value.end_date = format(new Date(), "YYYY-MM-DD");
      // 设置按钮名称为“近3月”
      dplusButtonName = "近3月";
      break;

    case 1:
      // 获取一年前的日期
      const oneYearAgo = new Date(now);
      oneYearAgo.setFullYear(now.getFullYear() - 1);
      // 设置 start_date 为一年前的日期
      parameter.value.start_date = format(oneYearAgo, "YYYY-MM-DD");
      // 设置 end_date 为当前日期
      parameter.value.end_date = format(new Date(), "YYYY-MM-DD");
      // 设置按钮名称为“近1年”
      dplusButtonName = "近1年";
      break;

    case 2:
      // 获取今年1月1日的日期
      const startOfYear = new Date(now);
      startOfYear.setMonth(0, 1); // 设置为今年1月1日
      startOfYear.setHours(0, 0, 0, 0); // 时间设置为00:00:00.000
      // 设置 start_date 为今年1月1日
      parameter.value.start_date = format(startOfYear, "YYYY-MM-DD");
      // 设置 end_date 为当前日期
      parameter.value.end_date = format(new Date(), "YYYY-MM-DD");
      // 设置按钮名称为“今年以来”
      dplusButtonName = "今年以来";
      break;

    case 3:
      // 设置 start_date 为空
      parameter.value.start_date = "";
      // 设置 end_date 为空
      parameter.value.end_date = "";
      // 设置 count 为 9999
      parameter.value.count = 9999;
      // 设置按钮名称为“全部”
      dplusButtonName = "全部";
      break;

    default:
      break;
  }
  // 更新 parameter 的 count
  parameter.count = getDayDifference(
    parameter.value.start_date,
    parameter.value.end_date
  );
  // 打印 parameter 对象
  console.log("parameter", parameter.value);
  // 调用 getData 函数获取数据
  getData();
};
// 定义一个异步函数，用于获取数据
const getData = async () => {
  // 获取组合收益 K 线数据
  const combinationIncomeKline = await getCombinationIncomeKline();

  // 打印组合收益 K 线数据
  console.log("combinationIncomeKline", combinationIncomeKline);
  // 定义股票 K 线参数对象
  const stockKlineParams = {
    startDate: combinationIncomeKline[0].init_date.replaceAll("-", ""),
    endDate: combinationIncomeKline[
      combinationIncomeKline.length - 1
    ].init_date.replaceAll("-", ""),
    // jsonpCallback: callbackName,
  };
  // 打印股票 K 线参数对象
  console.log("stockKlineParams", parameter.value);
  // 获取股票 K 线数据
  const stockKline = await getStockDetail(stockKlineParams);

  // 获取股票 K 线数据的第一项
  const stockKlineData = stockKline.data;

  // 将组合收益 K 线数据赋值给 rateData
  rateData.value = combinationIncomeKline;
  // 遍历组合收益 K 线数据，添加 xAxis, rate, sse300Rate 属性
  combinationIncomeKline.map((item, index) => {
    rateData.value[index].xAxis = item.init_date; // 设置 xAxis 为 init_date
    rateData.value[index].rate = parseFloat(toDecimal(item.income_rate * 100)); // 设置 rate 为收入率的百分比
    rateData.value[index].sse300Rate = stockKlineData[index]
      ? (stockKlineData[index].yields * 100).toFixed(2) // 设置 sse300Rate 为沪深300的收益率
      : ""; // 如果没有数据，设置为空字符串
  });

  // 如果 rateData 有数据，设置 handelEchartsData
  if (rateData.value.length > 0) {
    handelEchartsData.value = [
      {
        axisValue: rateData.value[rateData.value.length - 1].xAxis, // 设置 axisValue 为最后一个数据的 xAxis
        value: rateData.value[rateData.value.length - 1].rate, // 设置 value 为最后一个数据的 rate
      },
      {
        axisValue: rateData.value[rateData.value.length - 1].xAxis, // 设置 axisValue 为最后一个数据的 xAxis
        value: rateData.value[rateData.value.length - 1].sse300Rate, // 设置 value 为最后一个数据的 sse300Rate
      },
    ];
  }
  // 打印股票 K 线数据和 handelEchartsData
  console.log("stockKline", stockKlineData, combinationIncomeKline);

  // 在下一个 DOM 更新周期后调用 setEcharts 函数
  nextTick(() => {
    setEcharts();
  });
};

// 定义一个函数，用于获取组合收益 K 线数据
const getCombinationIncomeKline = () => {
  // 返回一个 Promise 对象
  return new Promise((resolve, reject) => {
    // 调用 getDetail API 获取数据
    getDetail("410002", JSON.stringify(parameter.value)).then((result) => {
      // 解析 JSONP 响应
      const res = parseJSONP(result);
      // 打印获取到的账户每日收益率列表
      console.log("getAccountDailyRateList", res);
      // 如果响应码为 "0000"，表示成功
      if (res.code === "0000") {
        // 打印获取到的账户每日收益率列表
        console.log("getAccountDailyRateList", res);
        // 解析结果并返回
        resolve(res.result);
      } else {
        reject(new Error("获取数据失败"));
      }
    });
  });
};

// 在组件挂载时调用 getData 函数
onMounted(() => { //NOSONAR
  getData();
});
// 定义一个响应式的对象变量，用于存储处理后的 ECharts 数据
const handelEchartsData = ref(null);

// 导入 ECharts 库
import * as echarts from "echarts";
// 定义一个响应式的引用变量，用于存储 ECharts 容器的 DOM 元素
const showorders = ref(null);
// 定义一个函数，用于设置 ECharts 图表
const setEcharts = () => {
  // 获取 ECharts 容器的 DOM 元素
  var chartDom = showorders.value;
  // 打印 ECharts 容器的 DOM 元素
  console.log("chartDom", chartDom);
  // 初始化 ECharts 实例
  const myChart = echarts.init(chartDom);
  // 定义 ECharts 配置项
  var option;
  // 定义 X 轴数据数组
  const xAxis = [];
  // 定义投资组合数据数组
  const tzData = [];
  // 定义沪深300数据数组
  const sseData = [];
  // 遍历 rateData 数据，填充 X 轴、投资组合数据和沪深300数据
  rateData.value.map((item) => {
    xAxis.push(item.xAxis); // 添加 xAxis 数据
    tzData.push(item.rate); // 添加投资组合数据
    sseData.push(item.sse300Rate); // 添加沪深300数据
  });

  // 定义 ECharts 配置项
  option = {
    tooltip: {
      show: true, // 显示提示框
      trigger: "axis", // 触发方式为坐标轴触发
      formatter: function (params) {
        // 自定义提示框内容
        console.log("tooltip", params);
        handelEchartsData.value = params; // 更新 handelEchartsData
        return ""; // 返回空字符串，自定义内容在外部处理
      },
      axisPointer: {
        type: "line", // 坐标轴指示器类型为直线
        snap: true, // 坐标轴指示器是否自动吸附到最近的点上
        handle: {
          show: true, // 显示手柄
        },
        show: true, // 显示坐标轴指示器
        animation: false, // 关闭动画效果
      },
    },
    grid: {
      top: "20%", // 距离容器顶部的距离
      left: "0%", // 距离容器左侧的距离
      right: "0%", // 距离容器右侧的距离
      bottom: "8%", // 距离容器底部的距离
      containLabel: true, // 包含标签
    },
    color: ["#FD8300", "#0B69FE"], // 颜色配置
    xAxis: {
      boundaryGap: false, // 坐标轴两边不留白
      type: "category", // 类目轴
      data: xAxis, // X 轴数据
      axisLine: {
        show: false, // 不显示坐标轴轴线
      },
      axisTick: {
        show: false, // 不显示坐标轴刻度
      },
      axisLabel: {
        show: true, // 显示坐标轴标签
        showMaxLabel: true, // 显示最大标签
        boundaryGap: 0, // 标签与轴线之间的间距
        textStyle: {
          color: "#393939", // X 轴文字颜色
        },
        formatter: function (value, index) {
          // 自定义 X 轴轴标签的显示内容
          // 在这个示例中，我们只显示第一个和最后一个标签
          if (index === 0) {
            return `						          ${value}`;
          } else if (index === xAxis.length - 1) {
            return `${value}					    	            `;
          } else {
            return "";
          }
        },
      },
    },
    yAxis: [
      {
        type: "value", // 数值轴
        axisLine: {
          show: false, // 不显示坐标轴轴线
          lineStyle: {
            color: "#eeeeee", // 坐标轴轴线颜色
          },
        },
        axisTick: {
          show: false, // 不显示坐标轴刻度
        },
        axisLabel: {
          color: "#393939", // 坐标轴标签颜色
          fontSize: 12, // 坐标轴标签字体大小
          formatter: "{value} %", // 坐标轴标签格式化
        },
        splitLine: {
          show: true, // 显示分割线
          lineStyle: {
            color: "#e7e9ef", // 分割线颜色
            type: "dashed", // 分割线类型为虚线
          },
        },
      },
    ],
    series: [
      {
        name: "投资组合", // 系列名称
        type: "line", // 系列类型为折线图
        symbolSize: 0, // 标记的大小
        lineStyle: {
          width: 1, // 线条宽度
          color: "#FD8300", // 线条颜色
        },
        data: tzData, // 数据
      },
      {
        name: "沪深", // 系列名称
        type: "line", // 系列类型为折线图
        symbolSize: 0, // 标记的大小
        lineStyle: {
          width: 1, // 线条宽度
          color: "#0B69FE", // 线条颜色
        },
        data: sseData, // 数据
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: "rgba(22, 119, 240, 0.2)" }, // 渐变填充起始颜色
            { offset: 1, color: "rgba(22, 119, 240, 0)" }, // 渐变填充结束颜色
          ]),
        },
      },
    ],
  };
  // 设置 ECharts 配置项
  option && myChart.setOption(option);
};
// 定义一个函数，根据传入的值返回相应的颜色
const setColor = (value) => {
  // 如果值大于 0，返回红色
  if (value > 0) {
    return "red";
  }
  // 如果值小于 0，返回绿色
  else if (value < 0) {
    return "green";
  }
  // 如果值等于 0，返回黑色
  else {
    return "black";
  }
};

// 定义一个函数，根据传入的日期字符串返回对应的周几名称
const setWeekend = (value) => {
  // 打印传入的日期字符串
  console.log(value);

  // 创建一个新的 Date 对象，将日期字符串传递给构造函数
  const dateObj = new Date(value);

  // 使用 getDay() 方法获取周几的数字（0 表示周日，1 表示周一，依此类推）
  const dayOfWeek = dateObj.getDay();

  // 定义一个数组，包含一周中每一天的名称
  const daysOfWeekNames = [
    "周日", // 0
    "周一", // 1
    "周二", // 2
    "周三", // 3
    "周四", // 4
    "周五", // 5
    "周六", // 6
  ];
  // 返回对应的周几名称
  return daysOfWeekNames[dayOfWeek];
};
</script>

<style scoped lang="scss">
.padding_15 {
  padding: 0 calc(var(--imgfontSize) * 30); /* 15px -> calc(var(--imgfontSize) * 30) */
}

.combinationIncome {
  background: #fff;
  padding: calc(var(--imgfontSize) * 48) calc(var(--imgfontSize) * 30); /* 24px, 15px -> calc(var(--imgfontSize) * 48), calc(var(--imgfontSize) * 30) */
  border-radius: calc(
    var(--imgfontSize) * 20
  ); /* 10px -> calc(var(--imgfontSize) * 20) */
}

.positionTitle {
  font-size: calc(
    var(--imgfontSize) * 36
  ); /* 18px -> calc(var(--imgfontSize) * 36) */
  color: #111;
  letter-spacing: 0;
  line-height: calc(
    var(--imgfontSize) * 40
  ); /* 20px -> calc(var(--imgfontSize) * 40) */
  font-weight: 500;
}

.dateTbas {
  width: calc(
    var(--imgfontSize) * 640
  ); /* 320px -> calc(var(--imgfontSize) * 640) */
  height: calc(
    var(--imgfontSize) * 64
  ); /* 32px -> calc(var(--imgfontSize) * 64) */
  background: #ffffff;
  border: 1px solid rgba(245, 245, 245, 1);
  border-radius: calc(
    var(--imgfontSize) * 8
  ); /* 4px -> calc(var(--imgfontSize) * 8) */
  display: flex;
  margin: calc(var(--imgfontSize) * 40) auto calc(var(--imgfontSize) * 24); /* 20px, 12px -> calc(var(--imgfontSize) * 40), calc(var(--imgfontSize) * 24) */
  justify-content: space-around;
  align-items: center;

  div {
    font-size: calc(
      var(--imgfontSize) * 26
    ); /* 13px -> calc(var(--imgfontSize) * 26) */
    color: #999999;
    letter-spacing: 0;
    font-weight: 600;
    text-align: center;
    line-height: calc(
      var(--imgfontSize) * 64
    ); /* 32px -> calc(var(--imgfontSize) * 64) */
    flex: 1;
  }

  .active {
    background: #f8f8f8;
    color: #262626;
  }
}

.echartsIllustrate {
  width: calc(
    var(--imgfontSize) * 690
  ); /* 345px -> calc(var(--imgfontSize) * 690) */
  height: calc(
    var(--imgfontSize) * 122
  ); /* 61px -> calc(var(--imgfontSize) * 122) */
  background: #f8f8f7;
  border-radius: calc(
    var(--imgfontSize) * 8
  ); /* 4px -> calc(var(--imgfontSize) * 8) */
  padding: calc(
    var(--imgfontSize) * 20
  ); /* 10px -> calc(var(--imgfontSize) * 20) */
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .date {
    font-size: calc(
      var(--imgfontSize) * 24
    ); /* 12px -> calc(var(--imgfontSize) * 24) */
    color: #7c7c7c;
    letter-spacing: 0;
    font-weight: 400;
  }

  .illustrate {
    display: flex;
    justify-content: space-between;
    align-items: center;

    & > div {
      width: 48%; /* 48% -> calc(var(--imgfontSize) * 96) */
      display: flex;
      justify-content: space-between;

      & > div {
        font-size: calc(
          var(--imgfontSize) * 24
        ); /* 12px -> calc(var(--imgfontSize) * 24) */
        color: #262626;
        letter-spacing: 0;
        font-weight: 500;
        display: flex;
        align-items: center;

        & > span {
          margin-right: calc(
            var(--imgfontSize) * 12
          ); /* 6px -> calc(var(--imgfontSize) * 12) */
          display: block;
          width: calc(
            var(--imgfontSize) * 16
          ); /* 8px -> calc(var(--imgfontSize) * 16) */
          height: calc(
            var(--imgfontSize) * 16
          ); /* 8px -> calc(var(--imgfontSize) * 16) */
          background: #fd8300;
        }

        .hushen {
          background: #0b69fe 100%;
        }
      }
    }
  }
}

.echarts {
  width: 100%;
  height: calc(
    var(--imgfontSize) * 400
  ); /* 200px -> calc(var(--imgfontSize) * 400) */
}

.noData {
  display: flex;
  justify-content: center;
  margin: calc(var(--imgfontSize) * 66) auto calc(var(--imgfontSize) * 64); /* 33px, 32px -> calc(var(--imgfontSize) * 66), calc(var(--imgfontSize) * 64) */

  img {
    width: calc(
      var(--imgfontSize) * 104
    ); /* 52px -> calc(var(--imgfontSize) * 104) */
  }
}
::v-deep .empty-wrap {
  padding-top: calc(var(--imgfontSize) * 26);
}
</style>
